<template>
  <div
    class="c-formError -has-error"
    v-if="message"
  >
    {{ message }}
  </div>
</template>
<script>
export default {
  name: 'FormError',
  props: {
    message: {
      type: String
    }
  },
  data() {
    return {}
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.c-formError {
  color: $color-app-error;
  font-size: 0.75rem;
}
</style>
